/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable import/no-unresolved */
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import toast, { Toaster } from 'react-hot-toast';
import { Link } from 'react-router-dom';
import TrackVisibility from 'react-on-screen';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import Navbar from 'modules/common/components/navbar';
import Footer from 'modules/common/components/footer';
import HeroImage from 'modules/common/assests/images/Artboard-1-24.png';
import { purchaseNFTSuccess } from 'modules/artworks/selector';
import 'animate.css';
import NFTCard from 'modules/common/components/card';
// import Disclosure from 'modules/common/components/disclosure';
import NetworkModel from 'modules/common/components/modal';
import FAQCard from 'modules/common/components/faq-card';
import bannerImage from 'modules/common/assests/images/banner-main.png';
import charityImage from 'modules/common/assests/images/charity.png';
import { getNFTsSlice } from './slice';
import { getNFTsList, checkConnectivity } from './selectors';

const faqs = [
  {
    id: 1,
    title: 'What is a crypto wallet?',
    description:
      'A crypto wallet is a program that helps you buy, sell, and store your cryptocurrency ...',
    image: 'gf',
    path: '/faq/wallet',
  },
  {
    id: 2,
    title: 'How to buy nft using GreenArt Coin?',
    description:
      'Once you’ve found an NFT you like, how do you actually purchase it? There are three ...',
    image: 'gf',
    path: '/faq/buy-coins',
  },
  {
    id: 3,
    title: 'How to create nfts using greenartcoin?',
    description:
      'Anyone can create an NFT. Your NFT can be as simple as the media itself, but it can ...',
    image: 'gf',
    path: '/faq/nft-creation',
  },
  {
    id: 4,
    title: 'What are gas fees?',
    description:
      'In web3, the term “gas fee” refers to the payment needed to execute transactions ...',
    image: 'gf',
    path: '/faq/gas-fees',
  },
  {
    id: 5,
    title: 'How to connect?',
    description:
      'Usually, when you try and connect to a dapp by clicking a "connect with MetaMask"...',
    image: 'gf',
    href: 'https://bit.ly/greenartcoin-wallet-connect',
  },
  {
    id: 6,
    title: 'How to Sell NFTs?',
    description:
      'Anyone can create an NFT. Your NFT can be as simple as the media itself, but it ...',
    image: 'gf',
    path: '/faq/sell-nfts',
  },
];

const Home = () => {
  const dispatch = useDispatch();
  const postsList = useSelector(getNFTsList);
  const connectivity = useSelector(checkConnectivity);
  const purchaseSuccess = useSelector(purchaseNFTSuccess);
  const [isOpen, setIsOpen] = useState(false);
  const [copiedText, setCopiedText] = useState({
    value: '',
    copied: false,
  });
  const fetchArtworks = async () => {
    await Promise.resolve(dispatch(getNFTsSlice.actions.getNFTs()));
  };
  function openModal() {
    setIsOpen(true);
  }
  useEffect(() => {
    fetchArtworks();
    if (connectivity?.chainId !== 97 || connectivity?.chainId === undefined) {
      openModal();
    }
  }, [purchaseSuccess]);
  //
  return (
    <>
      <div className="bg-[url('/src/modules/common/assests/images/home-background.png')] bg-no-repeat bg-cover h-auto">
        <Navbar />
        <div className='flex justify-center items-start h-auto mx-2 xl:mx-32 2xl:mx-56 py-4 xl:pt-0 xl:pb-8 2xl:py-8'>
          <div className='flex flex-col basis-1 lg:basis-3/5 px-4'>
            <img
              src={bannerImage}
              alt='banner'
              className='lg:scale-90 2xl:scale-110'
            />
            <div className='mt-8 flex justify-center'>
              <div className='lg:mx-4'>
                <a
                  href={
                    connectivity?.connected
                      ? 'https://greenartcoin.eu/nft/'
                      : '/'
                  }
                >
                  <button
                    type='button'
                    className='p-3 bg-transparent text-white font-medium hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 w-auto h-auto px-5 rounded border border-[#40A838]'
                  >
                    <span className='uppercase'>Sell your artworks</span>
                  </button>
                </a>
              </div>
              <div className='mx-4'>
                <Link to={connectivity?.connected ? '/my-artworks' : '/'}>
                  <button
                    type='button'
                    className='p-3 bg-transparent text-white font-medium hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 w-auto h-auto px-5 rounded border border-[#40A838]'
                  >
                    <span className='uppercase'>My NFTs</span>
                  </button>
                </Link>
              </div>
              <div className='mx-4'>
                <a
                  href={
                    connectivity?.connected
                      ? 'https://app.greenartcoin.eu/swap'
                      : '/'
                  }
                >
                  <button
                    type='button'
                    className='bg-gradient-to-b from-[#274728] to-[#40A838] p-3 shadow-lg shadow-green-500/50 hover:shadow-green-500/75 text-white font-medium hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 w-auto h-auto px-5 rounded'
                  >
                    <span className='uppercase'>Buy $GAC</span>
                  </button>
                </a>
              </div>
            </div>
            <div className='mt-8 flex justify-center items-center'>
              <div className='mx-2'>
                {' '}
                <img src={charityImage} alt='charity' className='w-28 h-auto' />
              </div>
              <div className='mx-2'>
                <a
                  // href={
                  //   connectivity?.connected ? 'https://greenartcoin.eu' : '/'
                  // }
                  href='https://greenartcoin.eu'
                >
                  <button
                    type='button'
                    className='bg-gradient-to-b from-[#E38125] to-[#ffa268] p-3 shadow-lg shadow-orange-500/50 hover:shadow-orange-500/75 text-white font-medium hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 w-auto h-auto px-5 rounded'
                  >
                    <span className='uppercase'>Back to home</span>
                  </button>
                </a>
              </div>
              <div className='mx-2 w-60'>
                {/* <span className='text-white capitalize'>
                  Contact Us To Buy NFTs NOW & Sustains Our Charity Projects.
                </span> */}
              </div>
            </div>
          </div>
          <div className='lg:flex hidden justify-center items-center h-auto py-6 basis-1 lg:basis-2/5'>
            <TrackVisibility>
              {({ isVisible }) => (
                <div
                  className={
                    isVisible ? 'animate__animated animate__zoomIn' : ''
                  }
                >
                  <img
                    src={HeroImage}
                    alt='hero'
                    className='w-[300px] banner'
                  />
                </div>
              )}
            </TrackVisibility>
          </div>
        </div>
      </div>
      <div>
        <div className='flex justify-evenly lg:justify-between mt-10 2xl:mt-20 xl:mx-[4rem]'>
          <div className=' flex lg:justify-start'>
            <h1 className="text-2xl xl:text-4xl 2xl:text-5xl font-['Poppins'] font-semibold text-[#272727]">
              Latest Artworks
            </h1>
          </div>
          <div className='flex items-center'>
            <Link to='/artworks'>
              <span className='font-medium text-lg lg:text-xl cursor-pointer'>
                More artworks
              </span>
            </Link>
          </div>
        </div>
        <div className='flex justify-center lg:mt-6 2xl:mt-12'>
          <div className='lg:grid xl:grid-cols-4 gap-16 sr-only lg:not-sr-only'>
            {postsList?.map(
              (post, index) =>
                index < 8 && (
                  <div>
                    <NFTCard
                      key={post.token_id}
                      token_id={post.token_id}
                      image={post.image}
                      title={post.name}
                      price={post.price}
                      seller={post.seller}
                      owner={post.currentOwner}
                    />
                  </div>
                )
            )}
          </div>
          <div className='grid grid-cols-1 lg:sr-only mt-6'>
            {postsList?.map(
              (post, index) =>
                index < 2 && (
                  <div>
                    <NFTCard
                      key={post.token_id}
                      token_id={post.token_id}
                      image={post.image}
                      title={post.name}
                      price={post.price}
                      seller={post.seller}
                      owner={post.currentOwner}
                    />
                  </div>
                )
            )}
          </div>
        </div>
        {postsList.length === 0 && (
          <div className='w-full flex justify-center'>No data...</div>
        )}
      </div>
      <div className='bg-[#0d111c]'>
        <div className='flex justify-center mt-16 pt-12'>
          <h1 className="text-5xl font-['Poppins'] font-semibold text-white">
            FAQ
          </h1>
        </div>
        <div className='flex justify-center pb-4'>
          <div className='flex justify-center lg:mt-6 2xl:mt-12'>
            <div className='lg:grid xl:grid-cols-3 gap-x-16 sr-only lg:not-sr-only'>
              {faqs.map((faq) => (
                <FAQCard
                  key={faq.id}
                  title={faq.title}
                  description={faq.description}
                  image={faq.image}
                  path={faq?.path}
                  href={faq?.href}
                />
              ))}
            </div>
          </div>
        </div>
        <div className='h-20 bg-white' />
        <Footer />
        <Toaster position='bottom-center' />
      </div>
      <NetworkModel
        setIsOpen={(value) => setIsOpen(value)}
        isOpen={isOpen}
        steps={null}
        title='Choose the relevant network.'
      >
        <div>
          <span className='text-white text-sm font-light'>
            This website is under construction. You need to choose Binance test
            network to access the functionalities of this website. You can
            follow below steps to configure in the test network.
          </span>
          <div className='text-white mt-4'>
            <h2>Network Name</h2>
            <CopyToClipboard
              text={copiedText.value}
              onCopy={() => {
                setCopiedText({
                  value: 'Binance Smart Chain Testnet',
                  copied: true,
                });
                toast.success('Copied to clipboard.', {
                  duration: 1500,
                });
              }}
            >
              <div className='glass-effect p-2 my-2 cursor-pointer'>
                <span>Binance Smart Chain Testnet</span>
              </div>
            </CopyToClipboard>
          </div>
          <div className='text-white mt-4'>
            <h2>New RPC URL</h2>
            <CopyToClipboard
              text={copiedText.value}
              onCopy={() => {
                setCopiedText({
                  value: 'https://data-seed-prebsc-1-s1.binance.org:8545/',
                  copied: true,
                });
                toast.success('Copied to clipboard.', {
                  duration: 1500,
                });
              }}
            >
              <div className='glass-effect p-2 my-2 cursor-pointer'>
                <span>https://data-seed-prebsc-1-s1.binance.org:8545/</span>
              </div>
            </CopyToClipboard>
          </div>
          <div className='text-white mt-4'>
            <h2>Chain ID</h2>
            <CopyToClipboard
              text={copiedText.value}
              onCopy={() => {
                setCopiedText({
                  value: '97',
                  copied: true,
                });
                toast.success('Copied to clipboard.', {
                  duration: 1500,
                });
              }}
            >
              <div className='glass-effect p-2 my-2 cursor-pointer'>
                <span>97</span>
              </div>
            </CopyToClipboard>
          </div>
          <div className='text-white mt-4'>
            <h2>Currency symbol</h2>
            <CopyToClipboard
              text={copiedText.value}
              onCopy={() => {
                setCopiedText({
                  value: 'BNB',
                  copied: true,
                });
                toast.success('Copied to clipboard.', {
                  duration: 1500,
                });
              }}
            >
              <div className='glass-effect p-2 my-2 cursor-pointer'>
                <span>BNB</span>
              </div>
            </CopyToClipboard>
          </div>
          <div className='text-white mt-4'>
            <h2>Block explorer URL (Optional)</h2>
            <CopyToClipboard
              text={copiedText.value}
              onCopy={() => {
                setCopiedText({
                  value: 'https://testnet.bscscan.com',
                  copied: true,
                });
                toast.success('Copied to clipboard.', {
                  duration: 1500,
                });
              }}
            >
              <div className='glass-effect p-2 my-2 cursor-pointer'>
                <span>https://testnet.bscscan.com</span>
              </div>
            </CopyToClipboard>
          </div>

          <div className='text-white mt-4'>
            <div className='flex justify-center my-2 cursor-pointer'>
              <button
                type='button'
                onClick={() => {
                  setIsOpen(false);
                }}
                className='bg-gradient-to-b from-[#274728] to-[#40A838] p-3 shadow-lg shadow-green-500/50 hover:shadow-green-500/75 text-white font-medium hover:text-white focus:outline-none focus:ring-2 w-auto h-auto px-5 rounded'
              >
                Understood
              </button>
            </div>
          </div>
        </div>
      </NetworkModel>
    </>
  );
};

export default Home;
